<template>
  <li class="fg-file-row">
    <a
      v-if="href"
      :href="href"
      target="_blank"
      class="fg-file-link"
    >
      <i class="fa fa-file-o" />
      {{ name }}
    </a>
    <span
      v-else
      class="fg-file-link"
    >
      <i class="fa fa-file-o" />
      {{ name }}
    </span>

    <label
      v-if="showToggle"
      class="fg-file-download-toggle"
      title="When on, dealers can download this file"
    >
      <input
        :checked="downloadable"
        type="checkbox"
        @change="$emit('toggle', $event.target.checked)"
      >
      Allow download
    </label>

    <button
      type="button"
      class="fg-file-remove"
      title="Remove"
      @click="$emit('remove')"
    >
      <i class="fa fa-trash" />
    </button>
  </li>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            required: true,
        },
        href: {
            type: String,
            default: null,
        },
        downloadable: {
            type: Boolean,
            default: false,
        },
        showToggle: {
            type: Boolean,
            default: true,
        },
    },
};
</script>

<style scoped>
.fg-file-row {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    border: 1px solid #edf0f2;
    border-radius: 8px;
    margin-bottom: 8px;
}
.fg-file-link {
    flex: 1 1 auto;
    min-width: 0;
    color: #2a9d8f;
    font-size: 14px;
    text-decoration: none;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.fg-file-link:hover {
    text-decoration: underline;
}
.fg-file-link .fa {
    margin-right: 6px;
    color: #8a94a6;
}
.fg-file-download-toggle {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    gap: 5px;
    margin: 0;
    font-size: 12px;
    font-weight: 500;
    color: #647285;
    cursor: pointer;
    white-space: nowrap;
}
.fg-file-download-toggle input {
    margin: 0;
}
.fg-file-remove {
    flex: 0 0 auto;
    border: 0;
    background: transparent;
    color: #adb5bd;
    cursor: pointer;
    padding: 4px 6px;
    border-radius: 4px;
    line-height: 1;
}
.fg-file-remove:hover {
    color: #e8554e;
    background: #fbeae6;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/faq_guideline/faq-guideline-file-row.vue